window.DownloadArea = function () {

    var exportStatus = {
        Unknown: 0,
        Completed: 1,
        Queued: 2,
        Running: 3,
        Failed: 4,
        Cancelled: 5,
        Cancelling: 6,

        getText: function (status) {
            switch (parseInt(status, 10)) {
                case this.Completed:
                    return locale.get("Completed", 1);
                case this.Queued:
                    return locale.get("Queued", 1);
                case this.Running:
                    return locale.get("Running", 1);
                case this.Failed:
                    return locale.get("Failed", 1);
                case this.Cancelled:
                    return locale.get("Cancelled", 1);
                case this.Cancelling:
                    return locale.get("Cancelling", 1);
                default:
                    return "Unknown";
            }
        }
    };

    var exportTypes = {
        PPT: 1,
        TemplateThumbnail: 2,
        PDF: 3,
        Excel: 4,
		CSV: 5,
		PPT_Screenshot: 6,
		PDF_Screenshot: 7,
		PPT_Native: 8,

        getText: function (type) {
            switch (parseInt(type, 10)) {
				case this.PPT:
				case this.PPT_Screenshot:
                    return "PPT";
                case this.PPT_Native:
                    return "PPT-editable";
				case this.PDF:
				case this.PDF_Screenshot:
                    return "PDF";
                case this.Excel:
                    return "Excel";
                case this.CSV:
                    return "CSV";
                default:
                    return "";
            }
        }
    };

    var progressUpdateIsActive = false;
    var exportsLoaded = false;
    var crossOrigin = isCrossOrigin();

    // JSonCalls
    function getExports(callback) {
        Helpers.perfJSonCall({
            method: "GetExports",
            data: { latest: !window.IsMyExports },
            service: "ReportService",
            successCallback: function (result) {
                if (callback) callback(result.exports);
                updateTotal(result.total);
                exportsLoaded = true;
            },
            fixCasing: true
        });
    }

    function deleteExports(guids) {
        if (confirm(locale.get("Are you sure you want to delete selected exports?", 1)))
            Helpers.perfJSonCall({
                method: "DeleteExports",
                service: "ReportService",
                data: { guids: guids },
                successCallback: function () {
                    $(guids).each(function () {
                        $("#tblDAExports tr[guid='" + this + "']").remove();
                    });
                    updateTotal($("#lnkMyExportsPageLink").attr("total") - guids.length);
                    if ($('#tblDAExports .trExportRow').length === 0)
                        $('.DAExportsContainer, .DAExportsToolbar, .DUI-OptionsPopup-title, .onlyExportsFromCurrentReport', '#divDownloadArea').css('display', 'none');
                    checkExport();
                },
                fixCasing: true
            });
    }

    function downloadExports(guids) {
        if (window.IsMyExports) window.showLoadingBar();
        Helpers.perfJSonCall({
            method: "GetMultipleExportsDownloadKey",
            service: "ReportService",
            data: { guids: guids },
            successCallback: function (downloadKey) {
                downloadExportFile(downloadKey);
                if (window.IsMyExports) window.hideLoadingBar();
            },
            failCallback: function() {
                if (window.IsMyExports) window.hideLoadingBar();
            },
            fixCasing: true
        });
    }

    function cancelExport(guid) {
        if (confirm(locale.get("Are you sure you want to cancel this export?", 1)))
            Helpers.perfJSonCall({
                method: "CancelExportByGuid",
                service: "ReportService",
                data: { guid: guid },
                successCallback: function () {
                    var statusLabel = $("#tblDAExports tr[guid='" + guid + "']").find(".lblExportStatus");
                    if (statusLabel.parent().attr("data-tooltip") == exportStatus.getText(exportStatus.Queued)) {
                        statusLabel.parent().attr("data-tooltip", exportStatus.getText(exportStatus.Cancelled));
                        statusLabel.attr('class', 'lblExportStatus ' + getExportStatusBadgeClassName(exportStatus.Cancelled));
                    } else {
                        statusLabel.parent().attr("data-tooltip", exportStatus.getText(exportStatus.Cancelling));
                        statusLabel.attr('class', 'lblExportStatus ' + getExportStatusBadgeClassName(exportStatus.Cancelling));
                    }

                    $("#tblDAExports tr[guid='" + guid + "']").find(".btnCancelExport").remove();
                },
                fixCasing: true
            });
    }

    function retryExport(guid) {
        var exportRow = $("#tblDAExports tr.trExportRow[guid='" + guid + "']");
        var statusLabel = exportRow.find(".lblExportStatus");

        statusLabel.parent().attr("data-tooltip", exportStatus.getText(exportStatus.Queued));
        statusLabel.attr('class', 'lblExportStatus ' + getExportStatusBadgeClassName(exportStatus.Queued));
        exportRow.find(".btnRetryExport").hide();

        Helpers.perfJSonCall({
            method: "RetryExportByGuid",
            service: "ReportService",
            data: { guid: guid },
            successCallback: function (exportDetails) {
                updateExportRow(exportRow, exportDetails);
                if (exportDetails.status == exportStatus.Queued || exportDetails.status == exportStatus.Running)
                    DownloadArea.initUpdateProgress();
            },
            failCallback: function () {
                statusLabel.parent().attr("data-tooltip", exportStatus.getText(exportStatus.Failed));
                statusLabel.attr('class', 'lblExportStatus ' + getExportStatusBadgeClassName(exportStatus.Failed));
                exportRow.find(".btnRetryExport").show();
			},
            fixCasing: true
        });
	}

    function getExportProgress(callback) {
        Helpers.perfJSonCall({
            method: "GetExportProgress",
            service: "ReportService",
            successCallback: function (exportStatus) { if (callback) callback(exportStatus); },
            fixCasing: true
        });
    }

    function getExportFileNameByGuid(exportedGuid, callback) {
        Helpers.perfJSonCall({
                method: "GetExportByGuid",
                service: "ReportService",
                data: { guid: exportedGuid },
                successCallback: function (response) { if (callback) callback(response); },
                fixCasing: true
            });
    }

    function clearExportProgress() {
        if (!progressUpdateIsActive)
            Helpers.perfJSonCall({
                method: "ClearExportProgress",
                service: "ReportService"
            });
    }

    // bind data to controls
    function rebindExports(exports) {
        $("#tblDAExports .trExportRow").remove();

        if (window.IsMyExports)
            $('#chbSelectAllExports').prop('checked', false);
        else
            $('#chbSelectAllExports').attr('checked', false);

        if (!window.IsMyExports) {
            showHideOnlyCurrentReportExportsFilter(exports);
            $('.DAExportsToolbar').css('padding-right', DUIWindowScrollbar.scrollbarWidth + 15);
            $('.onlyExportsFromCurrentReport').appendTo($('#lblExportFilenameHeader'));
            if (exports.length === 0) {
                $('.DAExportsContainer, .DAExportsToolbar, .DUI-OptionsPopup-title, .onlyExportsFromCurrentReport', '#divDownloadArea').css('display', 'none');
            }
        }

        $(exports).each(function () {
            DownloadArea.bindExportItem(this, true);
        });
    }

    function bindEvents() {
        $('#chbSelectAllExports').bind('change', DownloadArea.checkAllExports);
        $('#btnDeleteSelectedExports').bind('click', DownloadArea.deleteSelectedExports);
        $('#btnDownloadSelectedExports').bind('click', DownloadArea.downloadSelectedExports);
        $('#tblDAExports thead input[data-sort]').bind('click', sortExports);
        $('#chkOnlyExportsFromCurrentReport').bind('change', filterOnlyCurrentReportExports);
    }

    function getExportStatusBadgeClassName(status) {
        switch (parseInt(status, 10)) {
            case exportStatus.Queued:
                return "DUI-icon DUI-icon-busy text-mutted";
            case exportStatus.Completed:
                return "DUI-icon DUI-icon-downloads";
            case exportStatus.Running:
                return "DUI-icon DUI-icon-general-setings rotating text-success";
            case exportStatus.Failed:
                return "DUI-icon DUI-icon-warning";
            case exportStatus.Cancelled:
                return "DUI-icon DUI-icon-warning";
            case exportStatus.Cancelling:
                return "DUI-icon DUI-icon-general-setings rotating text-warning";
            default:
                return "badge";
        }
    }

	function bindExportItem(exportItem, append) {
		if ($("#tblDAExports").length < 1)
			return;
        var templateClass = "trExportRowTemplate";
        var rowClass = "trExportRow";

        var templateEl = $("#tblDAExports ." + templateClass).get(0);
        var exportRowHTML = templateEl ? templateEl.outerHTML : '';
        var exportRow = $(exportRowHTML);
        var iconID = '#DAExports-icon-'+ exportTypes.getText(exportItem.exportType) + (exportItem.exportSlidesAsScreenshot ? '-screenshot' : '');
   
        var date = moment(exportItem.utcStartDate);
        if (exportItem.timeZoneOffset != undefined)
            date = date.add(- exportItem.timeZoneOffset, 'minutes');

        exportRow
            .removeClass(templateClass)
            .addClass(rowClass)
            .toggleClass('completed', exportItem.status == exportStatus.Completed)
            .css('display', '');

        exportRow.attr("guid", exportItem.guid);
        exportRow.find(".icnExportType").get(0).setAttributeNS('http://www.w3.org/1999/xlink', 'href', iconID);
        exportRow.find(".btnExportFileName").text(exportItem.fileName).attr('title', exportItem.fileName);
        exportRow.find(".lblExportDate").text(date.format('YYYY-MM-DD'));
        exportRow.find(".lblExportFileSize").text(Helpers.bytesToReadableSize(exportItem.fileSize));
        if (exportItem.status == exportStatus.Failed)
            exportRow.find(".lblExportStatus").parent().attr("data-tooltip", exportItem.userMessage && exportItem.userMessage.length > 0 ? exportItem.userMessage : 'Unknown error, please contact support');
        else
            exportRow.find(".lblExportStatus").parent().attr("data-tooltip", exportStatus.getText(exportItem.status));
        exportRow.find(".lblExportStatus").attr('class', 'lblExportStatus ' + getExportStatusBadgeClassName(exportItem.status));
        exportRow.find(".lblExportReportName").text(HTMLHelpers.htmlDecode(exportItem.reportName));
        exportRow.find(".lblExportSendEmail").text(exportItem.sendEmail ? locale.get("Yes", 1) : locale.get("No", 1));
        exportRow.data('exportItem', exportItem);

        if (exportItem.status == exportStatus.Queued ||
            exportItem.status == exportStatus.Running ||
            exportItem.status == exportStatus.Cancelling) {
            exportRow.find(".chbExportSelected").attr('disabled', true);
        } else {
            exportRow.find(".chbExportSelected").attr('disabled', false);
        }

        if (exportItem.status != exportStatus.Queued && exportItem.status != exportStatus.Running)
            exportRow.find(".btnCancelExport").remove();
        else {
            exportRow.find(".btnCancelExport").unbind("click").bind("click", function() {
                cancelExport(exportItem.guid);
            });
            DownloadArea.initUpdateProgress();
        }

        exportRow.find(".btnRetryExport").toggle(exportItem.canRetry && (exportItem.status == exportStatus.Failed || exportItem.status == exportStatus.Cancelled));
        exportRow.find(".btnRetryExport").unbind("click").bind("click", function () {
            retryExport(exportItem.guid);
        });

        if (append)
            $("#tblDAExports tbody").append(exportRow);
        else
            $("#tblDAExports tbody").prepend(exportRow);

        if (exportItem.status != exportStatus.Completed) {
            exportRow.find(".btnExportFileName").attr("disabled", "disabled");
            exportRow.find(".btnExportFileName, .lblExportStatus, .DAExports-icon").unbind("click");
        } else {
            exportRow
                .find(".btnExportFileName, .lblExportStatus, .DAExports-icon")
                .bind("click", function () {
                    downloadExportFile(exportItem.guid);
                    return false;
                });
        }
        exportRow.find(".chbExportSelected").unbind("click").bind("click", checkExport);

        if (!window.IsMyExports)
            $('.DAExportsContainer, .DAExportsToolbar, .DUI-OptionsPopup-title', '#divDownloadArea').css('display', '');
    }

    function updateTotal(total) {
        $("#lnkMyExportsPageLink > span").text($("#lnkMyExportsPageLink").attr("originalText") + " (" + total + ")");
        $("#lnkMyExportsPageLink").attr("total", total);
    }

    function updateProgressNotification(completedExport) {
        if (window.IsMyExports) return;

        var exportActiveNotification;
        var notificationEl;
        var guid = completedExport.exportGuid;
        var failed = completedExport.status == exportStatus.Failed;

        var fileTypeIcon = '#DAExports-icon-'+ exportTypes.getText(completedExport.exportType);
        var fileTypeIconSVG = '<svg class="export-complete-icon"><use class="icnExportType" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + fileTypeIcon + '"></use></svg>';

        getExportFileNameByGuid(completedExport.exportGuid, renderNotification);

        function renderNotification(newName) {
            completedExport.fileName = newName;
            var fileName = completedExport.fileName;

            var messageText = locale.get(failed ? '%FileName% generation failed.' : '%FileName% generation completed.', 1);
            var message = fileTypeIconSVG +
                messageText.replace('%FileName%', '<b class="export-complete-name">' + fileName + '</b><span> ') + '</span>' +
                (failed && completedExport.message ? '<br/><span>' + completedExport.message + '</span>' : '') +
                '<i class="icon-close">×</i>';

            if (self === top || crossOrigin) {
                notificationEl = document.getElementsByClassName('export-complete-notification');
                if (notificationEl) DUImessage.hide(notificationEl);
                exportActiveNotification = DUImessage.show(message, (failed ? 'Message-error' : 'Message-success') + ' Message-closable export-complete-notification', 5000);
            } else {
                notificationEl = parent.document.getElementsByClassName('export-complete-notification');
                if (notificationEl) parent.DUImessage.hide(notificationEl);
                exportActiveNotification = parent.DUImessage.show(message, (failed ? 'Message-error' : 'Message-success') + ' Message-closable export-complete-notification', 5000);
            }

            if (!failed)
                $(exportActiveNotification).unbind().bind('click', function() {
                    downloadExportFile(guid);
                });

            $('.icon-close', exportActiveNotification).bind('click', function() {
                DUImessage.hide(exportActiveNotification);
                return false;
            });
        }
    }

    function showHideOnlyCurrentReportExportsFilter(exports) {
        var currentReportID = Helpers.getReportID();
        var currentReportExports = exports.filter(function(exportItem) { return exportItem.reportId === currentReportID });
        
        $('.onlyExportsFromCurrentReport')
            .css('display', exports.length === currentReportExports.length ? 'none' : '');
    }

    function filterOnlyCurrentReportExports(onlyCurrent) {
        var currentReportID = Helpers.getReportID();
        
        if (typeof onlyCurrent !== "boolean")
            onlyCurrent = this.checked;

        if (onlyCurrent !== false && currentReportID > 0)
            $("#tblDAExports").find('.trExportRow')
                .each(function() {
                    var exportItem = $(this).data('exportItem');
                    $(this).toggle(exportItem.reportId === currentReportID);
                });
        else
            $("#tblDAExports").find('.trExportRow').css('display', '');
    }

    // general
    function showExports() {
        if (!exportsLoaded) {
            getExports(rebindExports);

            $("#lblExportTypeHeader > span").text(locale.get("Type", 1));
            $("#lblExportReportHeader > span").text(locale.get("Report", 1));
            $("#lblExportStatusHeader > span").text(locale.get("Status", 1));
            $("#lblExportEmailHeader > span").text(locale.get("Email notification", 1));
            $("#lblExportFilenameHeader > span").text(locale.get("Filename", 1));
            $("#lblExportDateHeader > span").text(locale.get("Export date", 1));
            $("#lblExportFileSizeHeader > span").text(locale.get("File size", 1));

            $("#lblLatextExports").text(locale.get("Latest exports", 1));
            $("#lnkMyExportsPageLink > span").text(locale.get("My exports page", 1));
            $("#lnkMyExportsPageLink").attr("originalText", locale.get("My exports page", 1));
            $("#tblDAExports button.btnCancelExport").attr('data-tooltip', locale.get("Cancel", 1));
            $("#tblDAExports input.btnCancelExport").val(locale.get("Cancel", 1));
            $("#btnDeleteSelectedExports.DUIbuttonGray").val(locale.get("Delete selected", 1));
            $("#btnDownloadSelectedExports.DUIbuttonGray").val(locale.get("Download selected", 1));
            $("#btnDeleteSelectedExports.DUIButtonIcon").attr("data-tooltip", locale.get("Delete selected", 1));
            $("#btnDownloadSelectedExports.DUIButtonIcon").attr("data-tooltip", locale.get("Download selected", 1));
            $("label[for='chkOnlyExportsFromCurrentReport']").text(locale.get("Filter by current report", 1));

            if (window.IsFormReport && !(self === top || crossOrigin)) {
                $("#lnkMyExportsPageLink").css('display', 'none');
            }
        }
    }

    function checkAllExports(checked) {
        if (typeof checked !== "boolean")
            checked = this.checked;
        
        if (checked)
            $("#tblDAExports .trExportRow:visible input.chbExportSelected:not(:disabled)").each(function () {
                if (window.IsMyExports)
                    $(this).prop("checked", true);
                else
                    $(this).attr("checked", true);
            });
        else
            $("#tblDAExports .trExportRow input.chbExportSelected:not(:disabled)").each(function () {
                if (window.IsMyExports)
                    $(this).prop("checked", false);
                else
                    $(this).attr("checked", false);
            });

        $("#btnDeleteSelectedExports.DUIbuttonGray").attr("disabled", !checked);
        $("#btnDownloadSelectedExports.DUIbuttonGray").attr("disabled", !checked);
        $("#btnDeleteSelectedExports.DUIButtonIcon").toggle(checked);
        $("#btnDownloadSelectedExports.DUIButtonIcon").toggle(checked);
    }

    function checkExport() {
        var anyChecked = $("#tblDAExports .trExportRow input.chbExportSelected:not(:disabled):checked").length > 0;
        var anyUnchecked = $("#tblDAExports .trExportRow input.chbExportSelected:not(:disabled):not(:checked)").length > 0;
        
        $("#btnDeleteSelectedExports.DUIbuttonGray").attr("disabled", !anyChecked);
        $("#btnDownloadSelectedExports.DUIbuttonGray").attr("disabled", !anyChecked);
        $("#btnDeleteSelectedExports.DUIButtonIcon").toggle(anyChecked);
        $("#btnDownloadSelectedExports.DUIButtonIcon").toggle(anyChecked);
        if (window.IsMyExports)
            $('#chbSelectAllExports').prop('checked', anyChecked > 0 && anyUnchecked === 0);
        else
            $('#chbSelectAllExports').attr('checked', anyChecked > 0 && anyUnchecked === 0);
    }

    function sortExports() {
        var sortInput = $(this);
        var sortColumn = sortInput.attr('data-sort');
        var sortOrder = sortInput.attr('data-sort-order') || 'ASC';
        $(this).attr('data-sort-order', sortOrder === 'ASC' ? 'DESC' : 'ASC');

        var exports = $("#tblDAExports .trExportRow")
            .map(function(){ return $(this).data('exportItem'); })
            .toArray();
        
        var sort = function(exports, prop, sortOrder) {
            if (sortOrder === 'ASC')
                exports.sort(function(a, b) {
                    if (a[prop] < b[prop]) return -1;
                    if (a[prop] > b[prop]) return 1;
                    return 0;
                });
            else if (sortOrder === 'DESC')
                exports.sort(function(a, b) {
                    if (a[prop] < b[prop]) return 1;
                    if (a[prop] > b[prop]) return -1;
                    return 0;
                });
        }

        if (sortColumn === 'exportType') {
            exports
                .filter(function(exportItem) { return !exportItem.exportTypeText; })
                .forEach(function(exportItem) {
                    exportItem.exportTypeText = exportTypes.getText(exportItem.exportType);
                });
            sort(exports, 'exportTypeText', sortOrder);
        } else if (sortColumn === 'status') {
            exports
                .filter(function(exportItem) { return !exportItem.statusText; })
                .forEach(function(exportItem) {
                    exportItem.statusText = exportStatus.getText(exportItem.status);
                });
            sort(exports, 'statusText', sortOrder);
        } else {
            sort(exports, sortColumn, sortOrder);
        }

        rebindExports(exports);
        return false;
    }

    function downloadExportFile(downloadKey) {
        var iframe = document.createElement("iframe");
        iframe.src = "../Storyboard/DownloadFile.aspx?downloadKey=" + encodeURIComponent(downloadKey);
        iframe.style.display = "block";
        iframe.style.float = "left";
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.style.border = "0";
        iframe.name = "fileFrame";
        iframe.id = "fileFrame";
        document.body.appendChild(iframe);
    }

    function getSelectedGuids() {
        var guids = [];
        $("#tblDAExports tr.trExportRow").each(function() {
            if ($(this).find(".chbExportSelected").is(":checked"))
                guids.push($(this).attr("guid").toString());
        });
        return guids;
    }

    function deleteSelectedExports() {
        var guids = getSelectedGuids();
        if (guids.length > 0)
            deleteExports(guids);
    }

    function downloadSelectedExports() {
        var guids = getSelectedGuids();
        if (guids.length > 0)
            downloadExports(guids);
    }

    function initUpdateProgress() {
    	/* Temp disable notifications
        if (!window.IsMyExports && $('#exportProgressNotification').length === 0)
            DUImessage.show('<div id="exportProgressNotification"><span style="display: none">Active exports <b class="badge badge-info" id="lblActiveExports" style="margin-right: 2em"></b></span> <span style="display: none">Completed exports <b class="badge badge-success" id="lblCompleteExports"></b></span></div>', 'Message-info');
        */

        if (!progressUpdateIsActive) {
            progressUpdateIsActive = true;
            updateProgress();
        }
    }

    function updateProgress() {
        getExportProgress(function (progress) {
            if (self === top || crossOrigin) {
                updateTotal(progress.total);
            }

            Object.keys(progress.changedExports).map(function(key) {
                var exportRow = $("#tblDAExports tr.trExportRow[guid='" + key + "']");
                var updatedExport = progress.changedExports[key];
                
                updateExportRow(exportRow, updatedExport);

                if (self === top || crossOrigin) {
                    // Update export status in MyExport or Form report iframes
                    $('iframe#DUIframe, iframe.formReport').each(function() {
                        $(this).contents().find("#tblDAExports tr.trExportRow[guid='" + key + "']")
                            .each(function() {
                                updateExportRow($(this), updatedExport);
                            });
                    });
                } else {
                    // Update export status in parent window
                    $("#tblDAExports tr.trExportRow[guid='" + key + "']", window.parent.document)
                        .each(function() {
                            updateExportRow($(this), updatedExport);
                        });
                }
            });

            if (progress.active > 0)
                setTimeout(updateProgress, 5000); // TODO: install-level setting
            else
                progressUpdateIsActive = false;

            if (Object.keys(progress.changedExports).length > 0)
                $(document).trigger('DAPI.exportsChange', [progress]);
        });
    }

    function updateExportRow(exportRow, updatedExport) {
        var status = updatedExport.status;

        exportRow
            .toggleClass('completed', status == exportStatus.Completed)
            .find(".lblExportStatus")
                .attr('class', 'lblExportStatus ' + getExportStatusBadgeClassName(status))
                .parent().attr("data-tooltip", exportStatus.getText(status));

        if (status == exportStatus.Queued ||
            status == exportStatus.Running ||
            status == exportStatus.Cancelling) {
            exportRow.find(".chbExportSelected").attr('disabled', true);
        } else {
            exportRow.find(".chbExportSelected").attr('disabled', false);
        }

        if (status != exportStatus.Queued && status != exportStatus.Running)
            exportRow.find(".btnCancelExport").remove();

        exportRow.find(".btnRetryExport").toggle(updatedExport.canRetry && (status == exportStatus.Failed || status == exportStatus.Cancelled));

        if (status == exportStatus.Completed) {
            exportRow.find(".btnExportFileName").removeAttr("disabled");
            exportRow.find(".btnExportFileName, .lblExportStatus, .DAExports-icon").unbind("click");
            exportRow
                .find(".btnExportFileName, .lblExportStatus, .DAExports-icon")
                .bind("click", function () {
                    downloadExportFile(updatedExport.exportGuid);
                    return false;
                });
            updateProgressNotification(updatedExport);
        }
        if (status == exportStatus.Failed && updatedExport.message) {
            exportRow.find('.lblExportStatus').parent().attr('data-tooltip', updatedExport.message && updatedExport.message.length > 0 ? updatedExport.message : 'Unknown error, please contact support');
            updatedExport.fileName = exportRow.find("button.btnExportFileName").text();
            updateProgressNotification(updatedExport);
        }
        if (status == exportStatus.Running && updatedExport.totalHfilters > 0) {
            // TODO: multilanguage support
            exportRow.find(".lblExportStatus").parent().attr("data-tooltip", 
                locale.get("Running report %Current%/%Total%", 1).replace("%Current%", updatedExport.currentHfilter).replace("%Total%", updatedExport.totalHfilters));
        }
    }

    // exposed
    return {
        showExports: showExports,
        bindExportItem: bindExportItem,
        bindEvents: bindEvents,
        deleteSelectedExports: deleteSelectedExports,
        downloadSelectedExports: downloadSelectedExports,
        initUpdateProgress: initUpdateProgress,
        clearExportProgress: clearExportProgress,
        checkExport: checkExport,
        checkAllExports: checkAllExports
    };
} ();

$(document).ready(window.DownloadArea.bindEvents);